import { useTranslation } from 'react-i18next';

const featuredImages = [
  'https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20premium%20chunky%20white%20sneakers%20with%20gum%20soles%20photographed%20on%20a%20warm%20terracotta%20studio%20backdrop%20strong%20directional%20natural%20light%20crisp%20minimal%20sneaker%20product%20photography%20high%20detail%20editorial%20composition&width=800&height=800&seq=feat-sneakers-2026&orientation=squarish',
  'https://readdy.ai/api/search-image?query=A%20heavyweight%20heather%20grey%20oversized%20hoodie%20neatly%20folded%20on%20a%20soft%20sage%20green%20surface%20with%20gentle%20diffused%20light%20minimal%20streetwear%20product%20photography%20calm%20muted%20tones%20clean%20airy%20composition&width=800&height=800&seq=feat-hoodie-2026&orientation=squarish',
  'https://readdy.ai/api/search-image?query=A%20burnt%20orange%20graphic%20t-shirt%20folded%20flat%20on%20a%20warm%20cream%20linen%20background%20with%20soft%20shadows%20clean%20editorial%20product%20photography%20simple%20modern%20styling%20vibrant%20accent%20color%20calm%20composition&width=800&height=800&seq=feat-tee-2026&orientation=squarish',
  'https://readdy.ai/api/search-image?query=A%20deep%20olive%20green%20technical%20jacket%20on%20a%20wooden%20hanger%20against%20a%20light%20warm%20grey%20wall%20soft%20natural%20window%20light%20minimal%20outerwear%20product%20photography%20editorial%20style%20subtle%20fabric%20texture%20clean%20composition&width=800&height=800&seq=feat-jacket-2026&orientation=squarish',
];

export default function Featured() {
  const { t } = useTranslation();
  const items = t('home.featured.items', { returnObjects: true }) as Array<{ title: string; body: string }>;

  return (
    <section id="featured" className="w-full bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            {t('home.featured.title')}
          </h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            {t('home.featured.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {items.map((item, i) => (
            <div key={i} className="rounded-lg overflow-hidden bg-background-50 border border-background-200/70">
              <div className="w-full h-48">
                <img
                  src={featuredImages[i]}
                  alt={item.title}
                  title={`${item.title} AllChinaBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base">
                  {item.title}
                </h3>
                <p className="mt-2 text-foreground-600 text-xs md:text-sm leading-relaxed">
                  {item.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}